/* eslint-disable angular/controller-as */

angular.
module("dx.webapp.exams").
controller("DxStartExamPopupController", function StartExamPopupController(
	$scope,
	$rootScope,
	$location,

	course,
	dxApi,
	DX_DURATION_SETTING,
	dxLocalize,
	examStatus,
	DX_URLS,
	DX_INVIGILATOR_LOCATION_CONSTANTS,
	dxSession,
	RoleTypeEnum,

	dxDialog,

	Raven
) {
	"use strict";

	/**
	 * Required $scope values:
	 * - "exam", {Exam}
	 * - "schedule", {boolean}
	 *
	 * Optional $scope values:
	 * - "examCreatedCallback", {function}
	 * - "groupTitle", {string}
	 **/

	$scope.examStatus = examStatus;
	$scope.hasOnlineResource = false;

	$scope.examType = {
		open: "open",
		group: "group",
	};
	$scope.groups = [];
	$scope.timeValidationMessage = "";
	$scope.errorMessage = "";
	$scope.deletedToolsMessage = "";
	$scope.durationEnabled = $scope.exam.durationSetting > DX_DURATION_SETTING.OFF;
	$scope.DX_INVIGILATOR_LOCATION_CONSTANTS = DX_INVIGILATOR_LOCATION_CONSTANTS;
	$scope.invigilatorSave = false;
	$scope.examIsPlannedOrUnplanned = $scope.exam.examStatus === examStatus.PLANNED || $scope.exam.isUnplanned();
	$scope.confirmLoading = false;

	var locale = dxLocalize.getLanguage() ? dxLocalize.getLanguage() : "sv";
	var dateIsValid = false;
	var externalTools = [];

	$scope.durationObject = {
		duration: $scope.exam.duration,
		durationSetting: $scope.exam.durationSetting,
	};

	$scope.config = {
		group: null,
		examType: null,
		startTime: new Date(0),
	};

	$scope.Urls = DX_URLS;

	// localTimeWithZoneFormatted returns the current local time, time zone and UTC offset as a string.
	$scope.localTimeWithZoneFormatted = function localTimeWithZoneFormatted() {
		var dateTimeString = new Date().toString();
		var formattedTime = "";

		try {
			var zoneStart = dateTimeString.indexOf("(") + 1;
			var zone = dateTimeString.substring(zoneStart, dateTimeString.indexOf(")"));

			var dateTime = dateTimeString.split(" ");
			var time = dateTime[4].substring(0, 5);
			var offset = "(UTC" + dateTime[5].slice(dateTime[5].length - 5, dateTime[5].length - 2) + ":" + dateTime[5].substring(dateTime[5].length - 2) + ")";

			formattedTime = time + " " + zone + " " + offset;
		} catch (error) {
			Raven.captureException(error, {
				extra: {
					dateTimeString: dateTimeString,
				},
			});
		}

		return formattedTime;
	};

	$scope.timeZonePlannedExamHelpUrl = function timeZonePlannedExamHelpUrl() {
		if (dxLocalize.getLanguage() === "sv") {
			return "https://digiexam.zendesk.com/hc/sv/articles/207609895-Tidszoner-vid-planerade-prov";
		}

		return "https://digiexam.zendesk.com/hc/en-us/articles/207609895-Time-zones-and-planned-exams";
	};

	$scope.confirm = function confirm() {
		if ($scope.isConfirmDisabled()) {
			return;
		}
		$scope.errorMessage = null;
		$scope.incompleteExamId = null;

		$scope.confirmLoading = true;

		var req = {
			startNow: true,
		};

		if ($scope.schedule) {
			req.startNow = false;
			req.startTime = $scope.config.startTime;
		}

		if ($scope.durationObject.duration !== $scope.exam.duration) {
			req.duration = $scope.durationObject.duration;
		}

		if ($scope.durationObject.durationSetting !== $scope.exam.durationSetting) {
			req.durationSetting = $scope.durationObject.durationSetting;
		}

		if ($scope.examIsPlannedOrUnplanned) {
			dxApi.v1.exams.put($scope.exam.id, req).then(success, failed);
		} else {
			req.examTemplateId = $scope.exam.id;

			if ($scope.config.examType === $scope.examType.group) {
				req.groupId = $scope.config.group.id;
				req.courseId = $scope.config.group.parentCourseId;
			}

			dxApi.v1.exams.post(req).then(success, failed);
		}

		function success(response) {
			if ($scope.examCreatedCallback) {
				$scope.examCreatedCallback(response.data);
			}

			$scope.exam = response.data;
			$scope.examId = $scope.exam.id;

			if (!$scope.examIsPlannedOrUnplanned || $scope.schedule) {
				$scope.invigilatorSave = true;
			} else {
				showExamInfoPopup();
			}
		}

		$scope.invigilatorCallback = function invigilatorCallback(invigilatorSaveSuccess) {
			if (!invigilatorSaveSuccess) {
				$scope.errorMessage = "could not save invigilator"; // TODO fix real locale
				return;
			}

			showExamInfoPopup();
		};

		function showExamInfoPopup() {
			var scope = $rootScope.$new();
			scope.exam = $scope.exam;
			scope.scheduled = $scope.schedule;

			if (scope.exam.isGroupExam()) {
				scope.group = $scope.config.group;
			}

			dxDialog.show({
				templateUrl: "tmpl/exams/exam-info-popup.html",
				$scope: scope,
				clickOutsideToClose: false,
				escapeToClose: false,
			});
		}

		function failed(response) {
			$scope.confirmLoading = false;

			if (response.status === 403) {
				$scope.incompleteExamId = $scope.exam.id;
			} else {
				$scope.errorMessage = "StartExamPopup.CouldNotStartExam";
			}
		}
	};

	$scope.close = function close() {
		dxDialog.closeMostRecent();
	};

	$scope.goToCreate = function goToCreate(incompleteExamId) {
		dxDialog.closeMostRecent();
		return $location.path(DX_URLS.get("examEdit", {id: incompleteExamId}));
	};

	$scope.isConfirmDisabled = function isConfirmDisabled() {
		var invalidDate = $scope.schedule && !dateIsValid;
		var invalidDuration = $scope.durationObject.durationSetting > 0 && $scope.durationObject.duration === 0;
		var open = $scope.config.examType === $scope.examType.open;
		var group = ($scope.config.examType === $scope.examType.group) && $scope.config.group;
		var incompleteExamId = $scope.incompleteExamId;

		return invalidDate || (!open && !group) || $scope.confirmLoading || invalidDuration || incompleteExamId;
	};

	$scope.getStartNowText = function getStartNowText() {
		var startNowText = dxLocalize.get("StartExamPopup.StartNow") + " \"" + $scope.exam.title + "\"";

		startNowText += $scope.config.examType === $scope.examType.group ? " " + dxLocalize.get("StartExamPopup.For") : ".";

		return startNowText;
	};

	$scope.validateStartTime = function validateStartTime(error) {
		$scope.timeValidationMessage = "";

		if (error === "nodate") {
			$scope.timeValidationMessage = "StartExamPopup.StartDateNeeded";
			dateIsValid = false;
			return;
		}

		if (error === "invaliddate") {
			$scope.timeValidationMessage = "StartExamPopup.StartDateInvalid";
			dateIsValid = false;
			return;
		}

		if ($scope.config.startTime < new Date()) {
			$scope.timeValidationMessage = "StartExamPopup.StartDateTooEarly";
			dateIsValid = false;
			return;
		}

		dateIsValid = true;
	};

	function init() {
		if ($scope.examIsPlannedOrUnplanned) {
			$scope.config.examType = $scope.exam.isGroupExam() ? $scope.examType.group : $scope.examType.open;

			if ($scope.exam.parent) {
				$scope.examId = $scope.exam.id;
				if ($scope.schedule) {
					dateIsValid = true;
				}
			}

			if ($scope.exam.examStatus === examStatus.PLANNED) {
				$scope.config.startTime = new Date($scope.exam.start);
			}

			if ($scope.config.examType === $scope.examType.group) {
				$scope.config.group = {title: $scope.groupTitle};
			}
		} else {
			course.getAll().then(success, failed);
		}

		if (dxSession.getRole().roleType !== RoleTypeEnum.INVIGILATOR) {
			resolveHasOnlineResource();
		}

		dxApi.v1.externalTools.list($scope.exam.organizationId).then(function onSuccess(response) {
			externalTools = response.data;
			checkForDeletedExternalTools();
		}, function onFail() {
			$rootScope.$broadcast("notification:error", dxLocalize.get("ExternalTools.CouldNotLoadError.Plural"));
		});

		function success(response) {
			if (response.faults) {
				$scope.errorMessage = "StartExamPopup.CouldNotLoadGroups";
				return;
			}

			var courses = response.courses || [];

			courses.sort(alphabeticSortByTitle);

			for (var i = 0; i < courses.length; i++) {
				if (courses[i].externallyManaged) {
					continue;
				}

				var groups = courses[i].groups;

				groups.sort(alphabeticSortByTitle);

				for (var j = 0; j < groups.length; j++) {
					groups[j].parentCourseId = courses[i].id;
					groups[j].parentCourseTitle = courses[i].title;

					$scope.groups.push(groups[j]);

					if ($scope.exam.groupId === groups[j].id) {
						$scope.config.group = groups[j];
					}
				}
			}
		}

		function failed() {
			$scope.errorMessage = "StartExamPopup.CouldNotLoadGroups";
		}
	}

	function resolveHasOnlineResource() {
		dxApi.v1.examTemplates.questions.get($scope.exam.id).then(success);
		function success(response) {
			if (!response.data) {
				return;
			}

			for (var i = 0; i < response.data.length; i++) {
				if (response.data[i].onlineResources && response.data[i].onlineResources.length !== 0) {
					$scope.hasOnlineResource = true;
					return;
				}
			}
		}
	}

	function alphabeticSortByTitle(a, b) {
		return a.title.localeCompare(b.title, locale);
	}

	function checkForDeletedExternalTools() {
		var availableExternalToolsIds = externalTools.map(function mapFn(exTool) {
			return exTool.id;
		});

		var deletedExternalToolSettings = $scope.exam.getDeletedExternalToolSettings(availableExternalToolsIds);

		if (deletedExternalToolSettings.length > 0) {
			var deletedToolNames = deletedExternalToolSettings.map(function mapFn(settings) {
				return settings.title;
			});
			$scope.deletedToolsMessage = dxLocalize.get("ExternalTools.SomeDeletedWarning.OnExamStart", deletedToolNames.join(", "));
		}
	}

	init();
});
